import { Component,  Input, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { Label } from 'globals/store/events.data';
import { LabelMakerData, LabelMakerDialogComponent } from './label-maker.dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { LabelType } from '../../services/ui.service';
import { CommonModule } from '@angular/common';
import { LabelsViewComponent } from './labels-view.component';


@Component({
    selector: 'labels-row',
    template: `
<labels-view id="row" [labelMap]="labelMap" [labels]="labels" [ngClass]="{disabled: readOnly}" (click)="readOnly ? null : manageLabels($event)">
  <div class="missing" *ngIf="!labels || !labels.length">No {{ type }} labels</div>
  <div class="plus_label" *ngIf="!readOnly">+</div>
</labels-view>
`,
    styleUrls: ['labels-row.scss'],
    standalone: true,
    imports: [CommonModule, LabelsViewComponent]
})
export class LabelsRowComponent {
  @Input() labelMap: { [id: string]: Label }
  @Input() labelList: Label[]
  @Input() labels: string[]
  @Input() type: LabelType
  @Input() readOnly = true
  @Input() labelUpdateFunction
  @Output() addLabel: EventEmitter<any> = new EventEmitter()

  constructor(
    public dialog: MatDialog,
  ) { }

  manageLabels(event) {
    const parent = document.getElementById('row')
    const labelsRect = parent.getBoundingClientRect();

    const data: LabelMakerData = {
      labels: this.labels || [],
      type: this.type,
      position: { top: labelsRect.bottom - 2, left: labelsRect.left},
      labelUpdateFunction: this.labelUpdateFunction,
      labelTemplate: this.labelList,
    }

    this.dialog.open(LabelMakerDialogComponent, {
        minWidth: '300px',
        backdropClass: 'backdrop',
        panelClass: 'label-panel',
        maxHeight: '99vh',
        data
    });
  }


}



